/**
 * A flag as shapes, not as letters.
 *
 * A flag emoji is a pair of regional-indicator characters, and Windows ships no glyph for the
 * pair — every desktop browser there falls back to drawing the two letters, so the language
 * chooser read "GB", "MK", "AL", "TR" instead of showing flags. These are drawn, which looks the
 * same on every machine and asks nobody for a file.
 */
export default function Flag({ code, className = 'flag' }) {
  const shapes = FLAGS[code]

  if (!shapes) return null

  return (
    <svg className={className} viewBox="0 0 60 40" aria-hidden="true" focusable="false">
      {shapes}
    </svg>
  )
}

const FLAGS = {
  en: (
    <>
      <rect width="60" height="40" fill="#012169" />
      <path d="M0,0 60,40 M60,0 0,40" stroke="#fff" strokeWidth="9" />
      <path d="M0,0 60,40 M60,0 0,40" stroke="#C8102E" strokeWidth="4" />
      <path d="M30,0 V40 M0,20 H60" stroke="#fff" strokeWidth="13" />
      <path d="M30,0 V40 M0,20 H60" stroke="#C8102E" strokeWidth="7" />
    </>
  ),
  mk: (
    <>
      <rect width="60" height="40" fill="#D20000" />
      <path
        fill="#FFE600"
        d="M30,20 L60,26.93 L60,13.07 Z M30,20 L60,1.25 L42.5,0 Z M30,20 L34.62,0 L25.38,0 Z M30,20 L17.5,0 L0,1.25 Z M30,20 L0,13.07 L0,26.93 Z M30,20 L0,38.75 L17.5,40 Z M30,20 L25.38,40 L34.62,40 Z M30,20 L42.5,40 L60,38.75 Z"
      />
      <circle cx="30" cy="20" r="7.5" fill="#FFE600" stroke="#D20000" strokeWidth="1.6" />
    </>
  ),
  sq: (
    <>
      <rect width="60" height="40" fill="#E41E20" />
      <g fill="#000">
        <path d="M30,16.5 C31.6,16.5 32.8,17.4 33.2,18.6 L34.2,21.6 L33.4,22.4 L34.4,25.6 L32.6,26.4 L33.2,29 L31.4,29.6 L30,33 L28.6,29.6 L26.8,29 L27.4,26.4 L25.6,25.6 L26.6,22.4 L25.8,21.6 L26.8,18.6 C27.2,17.4 28.4,16.5 30,16.5 Z" />
        <path d="M27.4,18.6 C25.4,17.4 22.6,16.6 19.8,16.8 L22.6,18.4 L17.6,18.2 L21.2,20.4 L15.4,21.2 L20,23 L15.8,25.2 L21.6,24.8 L19.6,27.6 L25.2,24.2 L26.4,21.6 Z" />
        <path d="M32.6,18.6 C34.6,17.4 37.4,16.6 40.2,16.8 L37.4,18.4 L42.4,18.2 L38.8,20.4 L44.6,21.2 L40,23 L44.2,25.2 L38.4,24.8 L40.4,27.6 L34.8,24.2 L33.6,21.6 Z" />
        <path d="M28.4,17.4 C28,14.8 26.6,12.6 24.4,11.6 C22.4,10.7 20.4,11 19.6,12.2 L23,12.8 L19.4,14.2 L23.6,14.6 L22.6,16 L26.2,15.4 C26.8,16.2 27.4,16.9 28.4,17.4 Z" />
        <path d="M31.6,17.4 C32,14.8 33.4,12.6 35.6,11.6 C37.6,10.7 39.6,11 40.4,12.2 L37,12.8 L40.6,14.2 L36.4,14.6 L37.4,16 L33.8,15.4 C33.2,16.2 32.6,16.9 31.6,17.4 Z" />
      </g>
    </>
  ),
  tr: (
    <>
      <rect width="60" height="40" fill="#E30A17" />
      <circle cx="23" cy="20" r="9" fill="#fff" />
      <circle cx="26.5" cy="20" r="7.2" fill="#E30A17" />
      <path
        fill="#fff"
        d="M38.4,14.6 40.05,19.32 45.05,19.4 41.06,22.42 42.53,27.2 38.4,24.3 34.27,27.2 35.74,22.42 31.75,19.4 36.75,19.32 Z"
      />
    </>
  ),
}
